import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { compose } from 'redux';
import cn from 'classnames';
import Button from '../Form/Button';
import { colourThemeType } from '../../../propTypes';
import theme from '../../../styles/theme';

const SuccessMessage = ({
  classes, title, subtitle, buttonText, buttonLink, colourTheme,
}) => (
  <div className={cn(classes.message)}>
    <h2>
      {title}
    </h2>
    <p>
      {subtitle}
    </p>
    {(buttonText && buttonLink)
      && <Button text={buttonText} href={buttonLink} colourTheme={colourTheme} />}
  </div>
);

SuccessMessage.defaultProps = {
  buttonLink: '',
  buttonText: '',
};

SuccessMessage.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  buttonLink: PropTypes.string,
  buttonText: PropTypes.string,
  colourTheme: colourThemeType.isRequired,
};

export default compose(
  injectSheet({
    message: {
      padding: '5.5vw',
      [theme.breakpoints.down('md')]: {
        padding: '20px',
      },
    },
  }),
)(SuccessMessage);
